import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Profile = ({ data, refData }) => {
  const successNotification = (message) => toast.success(message);
  let now;
  if (data) {
    var myDate = new Date(data.date);
    now = myDate.getMonth() + 1 + '/' + myDate.getDate() + '/' + myDate.getFullYear();
  }

  const copyUserRefLink = () => {
    const txt = `${process.env.REACT_APP_WEBSITE_URL}/signup?ref=${refData.referralCode}`;
    const input = document.createElement('input');
    input.value = txt;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    successNotification('User referral link copied');
  };
  const copyMarketerRefLink = () => {
    const txt = `${process.env.REACT_APP_WEBSITE_URL}/marketer-signup?ref=${refData.referralCode}`;
    const input = document.createElement('input');
    input.value = txt;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    successNotification('Marketer referral link copied');
  };

  return (
    <div className="profilePage">
      {data && (
        <>
          <div className="top">
            <Link to={`${process.env.REACT_APP_IMG_BASEURL}/marketers/${data.coverImage}`}>
              <img
                src={`${process.env.REACT_APP_IMG_BASEURL}/marketers/${data.coverImage}`}
                alt=""
              />
            </Link>
          </div>

          <div className="bottom">
            <div className="row1">
              <p className="topTitle">
                My Profile
                <span>Level: {data.level}</span>
              </p>
              <p>
                <span>Created at: {now}</span>
                <span>Lives in: {data.city}</span>
              </p>
            </div>
            <div className="row2">
              <p>
                <span>{`${data.fName} ${data.lName}`}</span>
              </p>
              <p>
                Sex: <span>{data.gender}</span>
              </p>
            </div>
            <div className="row2">
              <p>
                DOB: <span>{data.dob}</span>
              </p>
              <p>
                Status: <span>{data.maritalStatus}</span>
              </p>
            </div>

            <p className="title">Contact Details</p>
            <div className="row2">
              <p>
                Email: <span>{data.email}</span>
              </p>
              <p>
                Phone: <span>{data.phone}</span>
              </p>
            </div>

            <div className="row3">
              Address: <span>{data.address}</span>
            </div>

            <p className="title">Employment Details</p>
            <div className="row2">
              <p>
                Occupation: <span>{data.occupation}</span>
              </p>
              <p>
                Employer: <span>{data.currentEmployer}</span>
              </p>
            </div>
            <div className="row3">
              Employment Address: <span>{data.employerAddress}</span>
            </div>

            <p className="title">Next of Kin Details</p>
            <div className="row2">
              <p>
                Next of Kin: <span>{data.nextOfKin}</span>
              </p>
            </div>
            <div className="row3">
              <p>
                Next of Kin Address: <span>{data.nextofKinAddress}</span>
              </p>
            </div>

            <div className="status">
              <p>Account Status: &nbsp;</p> {data.status} <div></div>
            </div>

            <div className="link">
              <Link className="link" to="/edit-profile">
                Update Profile
              </Link>
              <Link className="link" to="/update-password">
                Change Password
              </Link>
            </div>

            <div className="refBox mgt">
              <span>User Referral Link (Tap to copy):</span>
              <Link onClick={copyUserRefLink}>...signup?ref={refData.referralCode}</Link>
            </div>

            <div className="refBox">
              <span>Marketer Referral Link (Tap to copy):</span>
              <Link onClick={copyMarketerRefLink}>
                ...marketer-signup?ref={refData.referralCode}
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Profile;
